import { createContext } from 'react';
import type { AppUser } from '../services/appUser.service';

export interface PermissionsContextType {
  appUser: AppUser | null;
  isLoadingPermissions: boolean;
  hasPermission: (_perm: string) => boolean;
  refetchAppUser: () => Promise<void>;
}

export const PermissionsContext = createContext<PermissionsContextType | null>(null);
